var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17.801 15.801"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.385 0q.572-.001.995.416.422.416.42.979v9.336q.002.562-.42.978a1.37 1.37 0 0 1-.995.416h-6.2v2.386h1.262a.645.645 0 0 1 0 1.29H6.349a.645.645 0 0 1 0-1.29h1.26v-2.386H1.41q-.57.001-.99-.415a1.33 1.33 0 0 1-.42-.98V1.395Q0 .833.42.416T1.41 0zM1.31 1.295v9.536h15.174V1.295z"
  })));
};
export default SvgDevices;